import { render, staticRenderFns } from "./SelectNBS.vue?vue&type=template&id=4792ff5a&"
import script from "./SelectNBS.vue?vue&type=script&lang=js&"
export * from "./SelectNBS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports